import React, {useEffect} from 'react';
import {useFieldArray} from "react-hook-form";
import {v4 as uuidv4} from "uuid";
import {Portlet, PortletBody, PortletHeader, PortletHeaderToolbar} from "../../../components/Portlet";
import {Form} from "react-bootstrap";
import Button from "react-bootstrap/Button";
import FormHookInput from "../../air/airBooking/components/formHookInput";
import MileCardsInputs from "./mileCardsInputs";

const mileCardsTempData = {
  "airline": "",
  "number": "",
  "description": ""
}

const MileCardsForm = ({data, formController}) => {
  const {
    formState:{errors},
    control,
    } = formController
  const mileCardsControl = useFieldArray({
    control,
    name: `mileCards`,
    // rules: {required: true},
    keyName: 'customId',
  });
  const addNew = () =>{
    mileCardsControl.append(mileCardsTempData)
  }
  const removeCard = (index) =>{
    if(window.confirm('Вы уверены, что хотите удалить мильную карту?')){
      mileCardsControl.remove(index)
    }
  }

  useEffect(() => {
    mileCardsControl.replace(data)
  }, []);
  return (
    <>
      <Portlet>
        <PortletHeader title={'Мильные карты'} toolbar={<PortletHeaderToolbar >
          <Button size={'sm'} onClick={addNew} className={'ml-2'}>
            <i className="la la-plus"/>
            Добавить
          </Button>
        </PortletHeaderToolbar>}/>
        <PortletBody>
          {mileCardsControl.fields.map((item,index)=>{
            const prefix = `mileCards[${index}].`
            return <div key={item.customId} className={'d-flex gap-2 mb-3'} >
                <div className={'mt-4'}>{index+1}.</div>

              <MileCardsInputs formController={formController} prefix={prefix} item={item}/>
              <Button size={'sm'}
                      variant={'outline-danger'}
                      style={{height:'min-content', marginTop:'4px'}}
                      onClick={()=>removeCard(index)}>
                <i className="fa fa-trash"/>
              </Button>
            </div>
          })}
        </PortletBody>
      </Portlet>

    </>
  );
};

export default MileCardsForm;
